/* eslint-disable functional/no-conditional-statement */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/require-await */
import React from "react";
import ReactDOMClient from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { App } from "./app/components/App";
import "./common/styles/style-main.scss";
import reportWebVitals from "./reportWebVitals";
import { initializeDatadogRum } from "./common/miscellaneous/initializeDatadogRum";



async function initializeReact(): Promise<null> {
  // Defer non-critical initializations to improve LCP
  function deferredInitialization() {
    initializeDatadogRum();
    reportWebVitals();
  }
  const rootElement = document.getElementById("root");

  if (rootElement === null) {
    throw new Error("rootElement null");
  } else {
    const root = ReactDOMClient.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <RecoilRoot>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </RecoilRoot>
      </React.StrictMode>
    );

    // Use requestIdleCallback or setTimeout to defer until after initial paint
    if ("requestIdleCallback" in window) {
      requestIdleCallback(deferredInitialization);
    } else {
      setTimeout(deferredInitialization, 1);
    }

    return null;
  }
}

initializeReact();
